export default __webpack_public_path__ + "static/media/flag.bb851604.svg";